export const controleEstoqueAtivo = (valor: unknown): boolean => {
  return valor === true || valor === "true" || valor === 1 || valor === "1";
};

export const quantidadeEstoqueNumerica = (valor: unknown): number => {
  if (typeof valor === "number") {
    return Number.isFinite(valor) ? valor : 0;
  }

  const quantidade = Number(String(valor ?? "0").trim().replace(",", "."));
  return Number.isFinite(quantidade) ? quantidade : 0;
};

export const itemEsgotado = (item: any): boolean => {
  return controleEstoqueAtivo(item?.controlarEstoque)
    && quantidadeEstoqueNumerica(item?.quantidadeEstoque) <= 0;
};
